import { Checkbox, CheckboxProps, FormControlLabel, makeStyles } from "@material-ui/core";
import { useField, UseFieldProps } from "formik";
import { flexFormStyles } from "../containers/data/forms/forms-styles";

interface IProps {
	label?: string;
	labelplacement?: "end" | "start" | "top" | "bottom" | undefined;
	color?: "primary" | "secondary" | "default" | undefined;
	labelsize?: "small" | "medium" | undefined;
	attributeClasses?: string[];
}

export default function LACheckBox(props: CheckboxProps & UseFieldProps<any> & IProps) {
	const [field] = useField(props);
	const classes = useStyles({});
	const { attributeClasses } = props;

	return (
		<FormControlLabel
			control={
				<Checkbox
					size={props.labelsize}
					checked={Boolean(field.value)}
					color={props.color || "primary"}
					required={!!props.required && !field.value}
					{...field}
					{...props}
				/>
			}
			labelPlacement={props.labelplacement || "top"}
			label={props.label}
			style={flexFormStyles[attributeClasses && (attributeClasses as any)[0]]}
			classes={{
				label: !attributeClasses ? classes.label : "",
			}}
		/>
	);
}

const useStyles = makeStyles((theme) => ({
	label: {
		fontSize: "12px",
		color: theme.palette.grey[500],
	},
}));
